// src/components/admin/SyncPreview.tsx
import { Card } from "@/components/ui/card";

type KV = Record<string, any>;

function KVPairs({ data }: { data: KV }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
      {Object.entries(data).map(([k, v]) => {
        if (v === null || v === undefined) return null;
        if (typeof v === "object") return null; // on rend seulement les scalaires ici
        return (
          <div key={k} className="flex items-center justify-between rounded-md px-3 py-2 bg-muted">
            <span className="text-sm text-muted-foreground">{k}</span>
            <span className="font-medium">{String(v)}</span>
          </div>
        );
      })}
    </div>
  );
}

function MaybeTable({
  title,
  rows,
  columns,
}: {
  title: string;
  rows?: any[];
  columns?: string[];
}) {
  if (!rows || !rows.length) return null;
  const cols = columns && columns.length ? columns : Object.keys(rows[0] ?? {});
  return (
    <div className="mt-4">
      <div className="font-semibold mb-2">{title}</div>
      <div className="overflow-x-auto rounded-md border">
        <table className="w-full text-sm">
          <thead className="bg-muted">
            <tr>
              {cols.map((c) => (
                <th key={c} className="text-left px-3 py-2">
                  {c}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.slice(0, 50).map((r, i) => (
              <tr key={i} className="odd:bg-background even:bg-muted/30">
                {cols.map((c) => (
                  <td key={c} className="px-3 py-2">
                    {String(r?.[c] ?? "")}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {rows.length > 50 && (
        <div className="text-xs text-muted-foreground mt-1">
          (+{rows.length - 50} autres lignes non affichées)
        </div>
      )}
    </div>
  );
}

export function SyncPreview({ data }: { data: any }) {
  if (!data) return null;

  const {
    server,
    database,
    users_to_create,
    users_existing,
    reports_to_create,
    reports_existing,
    permissions_to_add,
    permissions_existing,
    sample,
    ...rest
  } = data || {};

  const counters: Record<string, any> = {
    server,
    database,
    users_to_create,
    users_existing,
    reports_to_create,
    reports_existing,
    permissions_to_add,
    permissions_existing,
  };

  return (
    <Card className="p-4">
      <div className="space-y-4">
        <KVPairs data={counters} />

        {/* Échantillons s’ils sont fournis par l’API */}
        <MaybeTable title="Exemples d’utilisateurs à créer" rows={sample?.users} />
        <MaybeTable title="Exemples de rapports (procédures) à créer" rows={sample?.reports} />

        {/* reste des détails en JSON brut pour transparence */}
        {Object.keys(rest || {}).length > 0 && (
          <div className="mt-2">
            <div className="text-sm text-muted-foreground mb-1">Détails</div>
            <pre className="text-xs p-3 rounded-md bg-muted/50 overflow-x-auto">
              {JSON.stringify(rest, null, 2)}
            </pre>
          </div>
        )}
      </div>
    </Card>
  );
}
